import React from "react";
import { ReactComponent as InfoIcon } from "../../../../assets/svg/info-icon.svg";
import { ReactComponent as ChartCustomisation } from "../../../../assets/svg/ChartCustomisation.svg";
import FacebookIcon from "../../../../assets/svg/facebook-icon.svg";
import RadarrIcon from "../../../../assets/svg/radarr-icon.svg";
import TwitterIcon from "../../../../assets/svg/twitter-logo.svg";
import InstagramIcon from "../../../../assets/svg/instagram.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import TikTokIcon from "../../../../assets/svg/tiktok-icon.svg";
import LinkedinIcon from "../../../../assets/svg/linkedin.svg";
import YoutubeIcon from "../../../../assets/svg/youtube-icon.svg";

const ChartName = ({
    name,
    info,
    isFacebook,
    isTwitter,
    IsInstagram,
    isFBPage,
    isTWPage,
    isIGPage,
    isTikTok,
    isTKPage,
    isLKPage,
    isLinkedin,
    chartCustomisation,
    isYTPage,
    isYoutube,
    removeCursor,
    advanceChart,
    chatGPT,
}) => {
    let excludedMatrix = "";
    if (chartCustomisation && chartCustomisation[0] !== "selectAll") {
        excludedMatrix = chartCustomisation.toString().replaceAll("_count", "s");
        excludedMatrix = excludedMatrix.replaceAll(",", ", ");
    }
    const getIcon = () => {
        if (isFacebook) {
            return <img src={FacebookIcon} className="company-icon" alt="facebook icon" />;
        } else if (isTwitter) {
            return <img src={TwitterIcon} className="company-icon" alt="twitter icon" />;
        } else if (IsInstagram) {
            return <img src={InstagramIcon} className="company-icon" alt="instagram icon" />;
        } else if (isTikTok) {
            return <img src={TikTokIcon} alt="tiktok icon" className="company-icon" />;
        } else if (isLinkedin) {
            return <img src={LinkedinIcon} alt="linkedin icon" className="company-icon" />;
        } else if (isYoutube) {
            return <img src={YoutubeIcon} alt="youtube icon" className="company-icon" />;
        } else {
            return <img src={RadarrIcon} alt="radarr icon" className="radarr-icon" />;
        }
    };

    return (
        <div
            className="chart-name"
            style={(isFBPage || isTWPage || isIGPage || isTKPage || isLKPage || isYTPage || removeCursor || chatGPT) && { cursor: "unset" }}>
            {!chatGPT && <div>{getIcon()}</div>}

            <span className="chart-title" title={name}>
                {name}
            </span>
            {info ? (
                <Popup
                    className="infoPopup skiptranslate"
                    position={advanceChart ? "bottom left" : "bottom center"}
                    header={name}
                    size="mini"
                    content={
                        advanceChart ? (
                            <pre style={{ fontSize: "12px", fontFamily: "'Roboto', sans-serif" }}>
                                <div style={{ fontWeight: "bold" }}>How to use a chart</div>
                                <div>
                                    Just drag and drop dimensions and metrics on the chart or add them using the +icon.
                                    <br />
                                    Save the chart when done and it will be saved and added to the dashboard
                                </div>
                                <div style={{ fontWeight: "bold" }}>
                                    {" "}
                                    <br />
                                    Dimensions
                                </div>
                                <div>
                                    These are variables that can be plotted on X-Axis. You can select 1 or 2 dimensions to be plotted on the X-Axis.
                                    <br />
                                    Examples include Platform, Country, Top Keywords etc. Please note that dimensions related to keywords can only be
                                    <br />
                                    plotted in Dimension 2 if another dimension has also been selected.
                                    <br />
                                </div>
                                <div style={{ fontWeight: "bold" }}>
                                    {" "}
                                    <br />
                                    Metrics
                                </div>
                                <div>
                                    These are values that are plotted on the Y-Axis. You can select 1 or 2 metrics to be plotted on the Y-Axis. Examples
                                    <br />
                                    include Volume of Conversations, Engagement etc.
                                    <br />
                                </div>
                                <div style={{ fontWeight: "bold" }}>
                                    {" "}
                                    <br />
                                    Limitations
                                </div>
                                <div>
                                    Some of the dimensions use sampling for faster performance due to the enormous volume of data that needs to be processed
                                    <br />
                                    to plot the charts. There may be minor (statistically insignificant) discrepancy in those charts. These dimensions
                                    <br />
                                    include keyword dimensions as well as top influencers. Influencers data is calculated using the impact created by
                                    influencers.
                                    <br />
                                </div>
                            </pre>
                        ) : (
                            info
                        )
                    }
                    trigger={
                        <div className="info-icon" data-html2canvas-ignore="true">
                            <InfoIcon />
                        </div>
                    }
                    // open
                    style={{ zIndex: "99999" }}
                />
            ) : null}
            {chartCustomisation && chartCustomisation[0] != "selectAll" && (
                <Popup
                    className="cutomisationPopup skiptranslate"
                    position="bottom center"
                    header={`Chart Customization applied`}
                    size="mini"
                    content={`Excluded metrics are ${excludedMatrix}`}
                    trigger={
                        <div className="customisation-icon" data-html2canvas-ignore="true">
                            <ChartCustomisation />
                        </div>
                    }
                    style={{ zIndex: "99999" }}
                />
            )}
        </div>
    );
};

export default ChartName;
